import { ContentType } from '../types/content/Content';
import Storage from './Storage';

export interface CachedContent {
  content: ContentType;
  cachedAt: number;
}

const cache: { [key: string]: CachedContent } = {};

export const CONTENT_CACHE_PREFIX = 'content_cache_';

export function getSync(id: any): ContentType | null | undefined {
  if (cache[id]) {
    return cache[id].content;
  }

  return null;
}

export async function get(id: any): Promise<ContentType | null | undefined> {
  if (cache[id]) {
    return cache[id].content;
  }

  try {
    const cachedData = await Storage.getItemMaybe(
      `${CONTENT_CACHE_PREFIX}${id}`
    );

    if (cachedData) {
      const { content, cachedAt } = cachedData as unknown as CachedContent;

      cache[id] = { content, cachedAt };

      return content;
    }

    return null;
  } catch (err) {
    console.error('Error getting content in cache:', err);

    return null;
  }
}

export async function set(content: ContentType) {
  const cachedContent: CachedContent = {
    content,
    cachedAt: Date.now(),
  };

  cache[content._id] = cachedContent;

  try {
    await Storage.setItem(
      `${CONTENT_CACHE_PREFIX}${content._id}`,
      cachedContent
    );
  } catch (err) {
    console.error('Error setting content in cache:', err);
  }
}

export async function clearCache() {
  for (const key of Object.keys(cache)) {
    try {
      await Storage.removeItem(`${CONTENT_CACHE_PREFIX}${key}`);
    } catch (err) {
      console.error(`Failed to remove content cache item "${key}":`, err);
    }

    delete cache[key];
  }
}

export default {
  getSync,
  set,
  get,
  clearCache,
};
